import { Component, Input } from '@angular/core';
import { MemoType } from '@careapp-group/core';

@Component({
    selector: 'ca-badge',
    styleUrls: ['./badge.component.scss'],
    templateUrl: 'badge.component.html',
    standalone: false
})
export class BadgeComponent {
  @Input() name: string;
  @Input() priority: MemoType;
  @Input() label: string;
}
